import { createContext, useCallback, useEffect, useMemo, useReducer } from "react"
import { fetchCategories, addCategoryNamesToArticles, fetchLastArticles } from "../services/ArticleService"
import { SET_CATEGORIES, SET_CENTRAL_ARTICLES, SET_ERROR, SET_IS_NEXT_BUTTON_DISABLED, SET_IS_PREVIOUS_BUTTON_DISABLED, SET_LOADING, SET_REACHED_FIRST_PAGE, setCategories, setCentralArticles, setError, setLoading } from "./ArticlesContextActions"
import { MODAL_DESCRIPTION_ERROR_ARTICLE_SEARCH_INVALID, MODAL_MESSAGE_ERROR, MODAL_TYPE_ERROR, NUMBER_OF_ARTICLES_ON_PAGE } from "../HistoriografijaConstants"
import { useModalContext } from "./ModalContext"

const ArticlesContext = createContext()

const initialState = {
    categories: [],
    centralArticles: [],
    isNextButtonDisabled: false,
    isPreviousButtonDisabled: true,
    reachedFirstPage: false,
    loading: true,
    error: null
}

/** Reducer */
const reducer = (state, action) => {
    switch (action.type) {
        case SET_CATEGORIES:
            return { ...state, categories: action.payload };
        case SET_CENTRAL_ARTICLES:
            return { ...state, centralArticles: action.payload };
        case SET_IS_NEXT_BUTTON_DISABLED:
            return { ...state, isNextButtonDisabled: action.payload };
        case SET_IS_PREVIOUS_BUTTON_DISABLED:
            return { ...state, isPreviousButtonDisabled: action.payload };
        case SET_REACHED_FIRST_PAGE:
            return { ...state, reachedFirstPage: action.payload };
        case SET_LOADING:
            return { ...state, loading: action.payload };
        case SET_ERROR:
            return { ...state, error: action.payload };
        default:
            return state
    }
}

export const ArticlesProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState)
    /** To track initial values, to not trigger change on initial run */
    const { displayGenericErrorModal, displayMessageModalWithParameters } = useModalContext()

    const handleException = useCallback((error) => {
        dispatch(setError(MODAL_DESCRIPTION_ERROR_ARTICLE_SEARCH_INVALID))
        dispatch(setLoading(false))
        if (error.response.status === 404) {
            displayMessageModalWithParameters(MODAL_MESSAGE_ERROR, MODAL_DESCRIPTION_ERROR_ARTICLE_SEARCH_INVALID, MODAL_TYPE_ERROR)
        } else displayGenericErrorModal()
        return
    }, [])

    /** Functions for refreshing context (or part of it) */
    const refreshArticlesContext = useCallback(() => {
        /** After fetching both articles and categories, set the category name to each article (because we only got categoryId). */
        // We use NUMBER_OF_ARTICLES_ON_PAGE instead of NUMBER_OF_ARTICLES_IN_CENTRAL in order to load more articles from context on the initial page load
        Promise.all([fetchLastArticles(NUMBER_OF_ARTICLES_ON_PAGE), fetchCategories()])   
        .then(([responseCentralArticles, responseCategories]) => {
          dispatch(setCategories(responseCategories))
          if (responseCentralArticles) {
            const centralArticlesWithCategoryNames = addCategoryNamesToArticles(responseCategories, responseCentralArticles.content)
            dispatch(setCentralArticles(centralArticlesWithCategoryNames))
            dispatch(setLoading(false))
          }
        })
        .catch(error => {
            handleException(error)
        })
    }, [])

    // Load of context
    useEffect(() => {
      refreshArticlesContext()
    }, [])
  
    const value = useMemo(() => {
        return  {state, dispatch, refreshArticlesContext}
    }, [state])

    return (
      <ArticlesContext.Provider value={value}>
        {children}
      </ArticlesContext.Provider>
    );
  };
  
export default ArticlesContext
